import styled from "@emotion/styled";
import { Avatar, ButtonBase, Box, Typography } from "@mui/material";
import { Link, NavLink, Navigate } from "react-router-dom";
import VideoPlayer from "react-video-js-player";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

export const MinuteStyle = styled(Box)(({ theme }) => (props) => ({
  color: theme.palette.mode === "dark" ? "#ffffff" : "#333333",
}));

export const Section = styled("main")(({ theme }) => (props) => ({
  display: "flex",
  padding: "5px 12px",
  minHeight: "100Vh",
  [theme.breakpoints.down("md")]: {
    padding: "12px 6px ",
    flexDirection: "column",
    gap: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "12px  6px ",
  },
  [theme.breakpoints.down("xs")]: {
    padding: "12px 6px",
  },
}));
export const LeftSection = styled("div")(({ theme }) => (props) => ({
  width: "18%",
  borderRadius: "8px",
  padding: "5px 0",
  borderRight: "1px solid #00000029 ",
  borderTop: "1px solid #00000029 ",
  boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.25)",
  margin: " 0 auto",
  [theme.breakpoints.down("lg")]: {
    width: "25%",
  },
  [theme.breakpoints.down("md")]: {
    width: "90%",
    display: "none",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    display: "none",
    padding: " 0",
    boxShadow: "none",
    borderRight: "none ",
    borderTop: "none ",
  },
}));
export const RightSection = styled("div")(({ theme }) => (props) => ({
  flex: 1,
  borderRadius: "8px",
  paddingLeft: "40px",
  [theme.breakpoints.down("md")]: {
    paddingLeft: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    borderLeft: "none ",
    paddingLeft: "0",
    width: "100%",
  },
}));
export const DetailsCourse = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  justifyContent: "center",
}));
export const DetailsTitle = styled("h4")(({ theme }) => (props) => ({
  fontSize: "20px",
  fontWeight: 500,
  // lineHeight: '29px',
  margin: " 16px 0",
  textAlign: "center",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
}));
export const ImageSection = styled("div")(({ theme }) => (props) => ({
  width: "144px",
  height: "144px",
}));
export const Image = styled("img")(({ theme }) => (props) => ({
  width: "100%",
  height: "100%",
  borderRadius: theme.shape.borderRadius,
}));
export const TextDiscretion = styled("p")(({ theme }) => (props) => ({
  fontSize: "1vw",
  fontWeight: "400",
  lineHeight: "1.2vw",
  letterSpacing: "0em",
  display: "block",
  margin: "0",
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.2vw",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "1.3vw",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    fontWeight: "600",
  },
}));
export const CompUser = styled("div")(({ theme }) => (props) => ({
  height: "50px",
  width: "80%",
  margin: " 10px 0px",
  borderRadius: theme.shape.borderRadius,
  border: "solid 1px",
  borderColor: theme.palette.primary.main,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
  [theme.breakpoints.down("md")]: {
    width: "50%",
    alignSelf: "start",
  },
  [theme.breakpoints.down("xs")]: {
    width: "100%",
  },
}));
export const ImageUser = styled("div")(({ theme }) => (props) => ({
  height: "35px",
  width: "35px",
}));
export const UserImage = styled("img")(({ theme }) => (props) => ({
  height: "100%",
  width: "100%",
  borderRadius: "50%",
}));

export const UserText = styled("p")(({ theme }) => (props) => ({
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "20px",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
}));
export const UserTextLight = styled("p")(({ theme }) => (props) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "20px",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.light
      : theme.palette.text.dark,
}));
export const LinkPart = styled(NavLink)(({ theme }) => (props) => ({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "20px",
  width: "100%",
  padding: "10px",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.light
      : theme.palette.text.dark,
  textDecoration: "none",
}));
export const TitleDisc = styled("div")(({ theme }) => (props) => ({
  fontSize: "20px",
  fontWeight: 600,
  lineHeight: "24px",
  //width: '100%',
  padding: "10px",
  margin: "0",
  display: "flex",
  alignItems: "center",
  gap: "16px",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
}));
export const PartDisc = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));
export const VideoPart = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  alignItems: "center",
  gap: "2px",
  flexDirection: "column",
}));
export const VideoLink = styled(Link)(({ theme }) => (props) => ({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "17px",
  width: "90%",
  padding: "10px",
  margin: "0",
  textDecoration: "none",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
  display: "flex",
  alignItems: "center",
  gap: "5px",
}));
export const VideoSection = styled("div")(({ theme }) => (props) => ({
  width: "95%",
  maxHeight: "500px",
  borderRadius: "10px",
  background: props.loading
    ? theme.palette.mode === "light"
      ? theme.palette.background.lightSecondary
      : theme.palette.background.darkSecondary
    : "transparent",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "auto",
  },
}));
export const VideoPlay = styled("div")(({ theme }) => (props) => ({
  width: "100%",
  maxHeight: "500px",
  height: "484px",
  borderRadius: "10px",
  backgroundSize: "cover",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  "& .vjs-poster ": {
    backgroundSize: "cover",
  },
}));
export const QuestsComp = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  overflowY: "auto",
  maxHeight: "50vh",
}));

export const ContentFlex = styled("div")(({ theme }) => (props) => ({
  display: "flex",
  padding: "10px",
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  [theme.breakpoints.down("xs")]: {
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "start",
  },
}));

export const ButtonLink = styled(ButtonBase)(({ theme }) => (props) => ({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "17px",
  margin: "10 0",
  width: "90%",
  textDecoration: "none",
  color:
    theme.palette.mode === "light"
      ? theme.palette.text.lightSecondary
      : theme.palette.text.darkSecondary,
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  gap: "5px",
}));
//new

export const ContentBox = styled(Box)(({ theme }) => (props) => ({
  display: "flex",
  alignItems: "center",
  gap: "5px",
  padding: "16px 10px",
  border: "1px solid #00000029",
  borderLeft: "none",
  borderRight: "none",
}));
export const ContentBoxForm = styled(Box)(({ theme }) => (props) => ({
  width: "80%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: "10px auto",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  margin: "4px 0",
  padding: "0",
  borderRadius: "8px",
  boxShadow: "-2px 2px 5px 0px rgba(194, 184, 184, 0.75)",
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
  width: "98%",
}));
export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  display: "flex",
  justifyContent: "between",
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "#fff",

  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(0),
  },
}));
export const AccordionContentText = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));
export const AccordionText = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "500",
  color: "#000000",

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
export const AccordionTextDetails = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "400",
  color: "#333333",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));
export const AccordionContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));
export const AccordionContentVed = styled(Box)(({ theme, boxshadow }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  padding: "8px 10px",
  boxShadow: boxshadow ? boxshadow : "0px 1px 12px 0px #00000014",
  justifyContent: "space-between",
  alignItems: "center",
  textDecoration: "none",
  boxSizing: "border-box",
}));
export const AccordionContentVedItems = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "16px",
}));
export const Icon = styled("img")(({ theme }) => ({}));
export const ImgComUser = styled("div")(({ theme }) => ({
  width: "20px",
  height: "20px",
}));
